import { HashLink } from 'react-router-hash-link';


function EffortEstimation() {
  return (
    <div className="bg-projects2 absolute top-0 left-0 min-h-screen w-full bg-gray-100 flex flex-col items-center justify-start px-4 sm:px-8 scroll-mt-[80px] -mt-[80px]">
      
      <div className="w-full max-w-4xl mx-auto pt-2">
        <HashLink
            smooth
            to="/#resume-prof-projects"
            className="inline-flex items-center text-sm font-semibold text-gray-800 border border-blue-200 px-3 py-2 rounded-lg hover:bg-blue-50 hover:border-blue-400 hover:shadow-sm transition-all"
        >
            <span className="mr-1">←</span> Go back to Home
        </HashLink>
      </div>

      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-6 sm:p-10 space-y-6">
        <h1 className="text-3xl sm:text-4xl font-bold title-color">
          Data Availability & Effort Estimation
        </h1>
        <p className="text-md text-gray-500 italic">
          Client: Top-tier global bank | Duration: Jul 2025 – Present
        </p>

        <section>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Overview</h2>
          <p className="text-gray-700 mb-2">
            A self-service application designed to help stakeholders estimate effort, data requirements, and delivery timelines for new data pipeline development. The tool allows users to input Use Case, Region, and Date Period through an interactive NiceGUI interface and provides dynamic feedback on data availability, ingestion needs, complexity level, and recommended datasets with metadata.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li><strong>Role:</strong> Data Scientist</li>
            <li>Spearheading the project as solution architect and team lead, guiding a team of 3 developers.</li>
            <li>Designed backend architecture using Python and JSON-based data stores to deliver contextual insights.</li>
            <li>Built frontend with NiceGUI and custom CSS for user-driven input and automated output generation.</li>
            <li>Implemented logic to classify complexity, estimate effort in sprints, and generate Gantt charts.</li>
            <li>Developed modules to fetch metadata, mark ingestion needs, and map available assets.</li>
            <li>Created fallback module using TF-IDF and cosine similarity to match described use cases semantically.</li>
            <li>Defined roadmap for LLM integration with governance mechanisms.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Key Responsibilities</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              <strong>Pre-Engagement Assessment:</strong> Enabled stakeholders to evaluate feasibility and delivery expectations before approaching data teams.
            </li>
            <li>
              <strong>Reduced Manual Dependency:</strong> Automated early consultation and effort planning, reducing manual consultation overhead by ~12-15%.
            </li>
            <li>
              <strong>Semantic Matching:</strong> Achieved 80%+ accuracy in use case extraction via TF-IDF-based fuzzy matching during MVP, eliminating need for immediate LLM support.
            </li>
            <li>
              <strong>Positive Pilot Reception:</strong> Received encouraging feedback with plans for scale-up and deeper onboarding integration.
            </li>
          </ul>
        </section>

      </div>
    </div>
  );
}
  
  export default EffortEstimation;  